const flmVersion='20230521T1034'

export const LATEST_BIG_CHANGE_VERSION = '2022-11-21';
export {flmVersion};

